export default "__VITE_ASSET__9ceef213__"